<template>
  <v-card style="padding: 0 24px;" @click="showRanking()">
    <v-row>
      <v-col>
        <v-row class="tiro-certeiro-row">
          <v-col cols="3">
            <div class="gray-label">Prémio</div>
            <div class="black-value">{{ tiroCerteiro.prize }}</div>
            <div class="gray-label">{{ tiroCerteiro.description }}</div>
          </v-col>
          <v-col cols="2">
            <div class="gray-label">Data Início</div>
            <div class="black-value" style="text-transform: capitalize;">
              {{ startDate.format("D MMMM YYYY") }}
            </div>
          </v-col>
          <v-col cols="2">
            <div class="gray-label">Data Fim</div>
            <div class="black-value" style="text-transform: capitalize;">
              {{ endDate.format("D MMMM YYYY") }}
            </div>
          </v-col>
          <v-col>
            <div class="gray-label">Dias para acabar</div>
            <div class="black-value">
              {{ remaining }} dias
              <CustomProgressBar
                :percentage="getPercentage()"
              ></CustomProgressBar>
            </div>
          </v-col>
          <v-col cols="2">
            <v-row justify="end">
              <v-btn
                depressed
                dark
                color="#D8E0E6"
                class="gray-button"
                style="margin-right: 8px;"
                @click.stop="editItem()"
                >Editar</v-btn
              >
              <RemoveItem :target="'tiro certeiro'" @remove-item="deleteItem()"></RemoveItem>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<style scoped>
.v-card {
  margin-bottom: 8px;
}
.tiro-certeiro-row .col .gray-label:nth-child(3) {
  font-family: Gilroy-SemiBold;
  font-size: 12px;
  line-height: 14px;
  color: #6d818f;
}
.tiro-certeiro-row .black-value {
  font-size: 14px;
  line-height: 16px;
}
.gray-label {
  font-family: Gilroy-SemiBold;
  font-size: 10px;
  line-height: 16px;
  color: #bcc5cc;
}
.black-value {
  font-family: Gilroy-Medium;
  color: #304351;
}
@media only screen and (max-width: 480px) {
  .tiro-certeiro-row .col {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>

<script>
import Vue from "vue";
import CustomProgressBar from "@/components/CustomProgressBar.vue";
import RemoveItem from "@/components/RemoveItem";

export default Vue.extend({
  name: "BackofficeTiroCerteiroCard",
  components: {
    CustomProgressBar,
    RemoveItem
  },
  props: {
    tiroCerteiro: {}
  },
  data: () => ({
    startDate: 0,
    endDate: 0,
    duration: 0,
    remaining: 0,
    percentage: 0
  }),
  created() {
    this.startDate = this.$moment(this.tiroCerteiro.startDate, "x");
    this.endDate = this.$moment(this.tiroCerteiro.endDate, "x");

    this.duration = this.$moment
      .duration(this.endDate.diff(this.startDate))
      .asDays();
    this.remaining = this.getRemainingDays();
  },
  methods: {
    dateDiff(end, now) {
      this.$moment.duration(this.$moment(end).diff(now));
    },
    getPercentage() {
      const percentage = (this.remaining * 100) / this.duration;
      return percentage;
    },
    getRemainingDays() {
      const now = this.$moment();
      let remaingDays;

      if (now.diff(this.startDate) < 0) {
        remaingDays =
          this.duration +
          this.$moment.duration(this.startDate.diff(now)).asDays();
      } else {
        remaingDays = this.$moment.duration(this.endDate.diff(now)).asDays();
      }
      return Math.max(0, Math.ceil(remaingDays));
    },
    editItem() {
      this.$emit("edit");
    },
    deleteItem() {
      this.$emit("delete");
    },
    showRanking() {
      console.log("Show Ranking")
      this.$emit("show-ranking");
    }
  }
});
</script>
